import { loadNotifications } from 'App/sources/Notifications';

import { useQuery } from '@gogame/query';

import { grid } from './queryKeyFactory';

export const useLoadNotifications = () => {
  return useQuery(grid(), (_, { signal }) => loadNotifications({}, { signal }));
};
